// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrder } from '@evolvemep/api-ts';

import { TaskPickerModal } from 'modules/Shop/Tasks/TaskTypes/TaskPickerModal';
import { AddTaskPopover } from 'modules/Shop/WorkOrders/WorkOrderDetail/Tasks/AddTaskPopover';

type Props = {
  workOrder: WorkOrder;
  onTasksAdded: () => void;
  opened: boolean;
  onClose: () => void;
};

export const AddTasksToItemsModal = ({ workOrder, onTasksAdded, opened, onClose }: Props) => (
  <TaskPickerModal
    title={workOrder.name}
    subtitle="Add tasks to items"
    miniHeader={workOrder.identifier}
    opened={opened}
    onClose={onClose}
    renderAction={(selectedTasks) => (
      <AddTaskPopover
        taskTypes={selectedTasks}
        workOrderId={workOrder.workOrderId}
        onTasksAdded={() => {
          onTasksAdded();
          onClose();
        }}
      />
    )}
  />
);
